export default function dataLayer ({ event, category, action, label }) {
  return window.dataLayer.push({
    event: event,
    categoria: category,
    acao: action,
    rotulo: label
  })
}
